import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePartner } from '@/contexts/PartnerContext';
import { Button } from '@/components/ui/button';
import { Key, Lock, ArrowRight } from 'lucide-react';

export function PartnerLoginPage() {
  const { login, isLoading, isAuthenticated } = usePartner();
  const navigate = useNavigate();
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');

  if (isAuthenticated) {
    navigate('/partner', { replace: true });
    return null;
  }

  const handleLogin = async () => {
    if (!apiKey.trim()) return;
    setError('');
    try {
      await login(apiKey.trim());
      navigate('/partner', { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Неверный API-ключ');
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0f1a] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-500/10 border border-blue-500/30 mb-4">
            <Lock className="w-7 h-7 text-blue-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1">Кабинет партнёра</h1>
          <p className="text-gray-500 text-sm">xPanda P2P API · Войдите по API-ключу</p>
        </div>

        {/* Form */}
        <div className="bg-[#161b27] border border-[#252d42] rounded-2xl p-6 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-2 block">
              API Key
            </label>
            <div className="relative">
              <Key className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
              <input
                type="password"
                value={apiKey}
                onChange={e => { setApiKey(e.target.value); setError(''); }}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                placeholder="Вставьте ваш API-ключ..."
                className="w-full bg-[#0d1220] border border-[#252d42] rounded-lg pl-10 pr-4 py-3 text-sm text-white font-mono outline-none focus:border-blue-500/50 transition-colors"
                autoFocus
              />
            </div>
          </div>

          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/25 rounded-lg text-sm text-red-400">
              <span>⚠</span>
              <span>{error}</span>
            </div>
          )}

          <Button
            onClick={handleLogin}
            disabled={isLoading || !apiKey.trim()}
            className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-40"
          >
            {isLoading ? (
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <>
                Войти
                <ArrowRight className="w-4 h-4 ml-2" />
              </>
            )}
          </Button>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-600 mt-6">
          Нет API-ключа?{' '}
          <a href="/b2b-api" className="text-blue-400 hover:underline">
            Узнать как получить
          </a>
        </p>
      </div>
    </div>
  );
}
